<template>
  <section class="decision-panel">
    <div class="panel-title">算法决策链路</div>
    <div class="decision-flow">
      <div v-for="(item, index) in steps" :key="item.title" class="decision-card">
        <span class="corner corner-tl"></span>
        <span class="corner corner-tr"></span>
        <span class="corner corner-bl"></span>
        <span class="corner corner-br"></span>
        <!-- <div class="icon">{{ index + 1 }}</div> -->
        <div class="hex-border">
          <!-- SVG 六边形边框 -->
          <svg viewBox="0 0 100 115.47" preserveAspectRatio="none">
            <polygon points="50 0, 100 28.87, 100 86.6, 50 115.47, 0 86.6, 0 28.87" />
          </svg>
          <!-- 内部数字 -->
          <span class="hex-num">{{ index + 1 }}</span>
        </div>
        <h4>{{ item.title }}</h4>
        <p>{{ item.desc }}</p>
        <i v-if="index < steps.length - 1" class="decision-link"></i>
      </div>
    </div>
  </section>
</template>

<script setup>
const steps = [
  { title: "数据接入", desc: "土壤墒情、土壤情报、空气温湿度、光照、水肥EC值" },
  { title: "清洗降噪", desc: "异常过滤、缺失修复、数值平滑处理" },
  { title: "模糊聚类", desc: "隶属度计算、多维分组、等级划分" },
  { title: "长势研判", desc: "正常区间、轻微胁迫、重度胁迫风险" },
  { title: "策略输出", desc: "灌溉、追肥、通风、植保、预警建议" },
];
</script>

<style lang="less" scoped>
.decision-panel {
  position: relative;
  min-height: 0;
  padding: 80px 0 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  // align-items: center;
  // justify-content: center;
  gap: 40px;
}

.panel-title {
  color: #f3fcff;
  font-size: 34px;
  font-weight: bold;
  text-shadow: 0 0 12px rgba(65, 255, 238, 0.65);
  text-align: center;
  position: relative;
  margin-bottom: 30px;
}

.panel-title::after {
  content: "";
  position: absolute;
  left: calc(50% - 180px);
  bottom: -20px;
  width: 360px;
  height: 2px;
  background: linear-gradient(90deg, rgba(95, 255, 240, 0), rgba(95, 255, 240, 0.85), rgba(95, 255, 240, 0));
  box-shadow: 0 0 12px rgba(95, 255, 240, 0.8);
}

.decision-flow {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
}

.decision-card {
  position: relative;
  display: flex;
  // width: 200px;
  // min-width: 154px;
  flex: 1;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 52px 16px 28px;
  box-sizing: border-box;
  border: 1px solid rgba(121, 255, 247, 0.76);
  border-radius: 6px;
  background:
    radial-gradient(ellipse at 50% 10%, rgba(82, 255, 240, 0.28), rgba(32, 187, 177, 0.12) 42%, transparent 72%),
    linear-gradient(180deg, rgba(7, 66, 65, 0.56), rgba(3, 48, 52, 0.5));
  box-shadow:
    inset 0 0 32px rgba(48, 255, 236, 0.22),
    inset 0 -18px 34px rgba(36, 218, 204, 0.13),
    0 0 18px rgba(46, 246, 230, 0.18);
}

.decision-card::before,
.decision-card::after {
  content: "";
  position: absolute;
  pointer-events: none;
}

.decision-card::before {
  inset: 4px 5px;
  border: 1px solid rgba(104, 255, 246, 0.08);
  box-shadow: inset 0 0 22px rgba(82, 255, 240, 0.16);
}

.decision-card::after {
  left: 11px;
  right: 11px;
  bottom: 4px;
  height: 1px;
  background: linear-gradient(90deg, rgba(98, 255, 247, 0.16), rgba(126, 255, 248, 0.9), rgba(98, 255, 247, 0.16));
  box-shadow: 0 0 10px rgba(102, 255, 247, 0.75);
}

.corner {
  position: absolute;
  z-index: 2;
  width: 26px;
  height: 26px;
  border-color: #8efff8;
  border-style: solid;
  filter: drop-shadow(0 0 5px rgba(107, 255, 246, 0.74));
}

.corner-tl {
  top: -1px;
  left: -1px;
  border-width: 3px 0 0 3px;
}

.corner-tr {
  top: -1px;
  right: -1px;
  border-width: 3px 3px 0 0;
}

.corner-bl {
  left: -1px;
  bottom: -1px;
  border-width: 0 0 3px 3px;
}

.corner-br {
  right: -1px;
  bottom: -1px;
  border-width: 0 3px 3px 0;
}

.decision-link {
  position: absolute;
  top: 50%;
  right: -36px;
  width: 30px;
  height: 1px;
  background: linear-gradient(90deg, rgba(98, 255, 247, 0.88), rgba(98, 255, 247, 0.18));
  box-shadow: 0 0 8px rgba(98, 255, 247, 0.72);
}

.decision-link::after {
  content: "";
  position: absolute;
  top: -6px;
  right: -2px;
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 10px solid rgba(98, 255, 247, 0.95);
  filter: drop-shadow(0 0 6px rgba(98, 255, 247, 0.82));
}


.hex-border {
  position: relative;
  width: 70px;          /* 六边形整体大小，可修改 */
  aspect-ratio: 1 / 1.1547; /* 维持正六边形比例，不用改 */
  display: flex;
  align-items: center;
  justify-content: center;
}

/* SVG 边框层 */
.hex-border svg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}
.hex-border polygon {
  fill: none;                /* 核心：无填充，内部完全透明 */
  stroke: #8BA09B;           /* 边框颜色 */
  stroke-width: 4;           /* 边框粗细，数值越大越粗 */
}

/* 内部数字样式 */
.hex-num {
  position: relative;
  color: #ffffff;
  font-size: 32px;
  font-weight: bold;
}
.decision-card h4 {
  margin: 36px 0 26px;
  color: #ffffff;
  font-size: 30px;
  font-weight: bold;
  line-height: 32px;
  text-align: center;
  white-space: nowrap;
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.35);
}

.decision-card p {
  margin: 0;
  color: #e6ffff;
  font-size: 22px;
  font-weight: bold;
  line-height: 40px;
  text-align: center;
  text-shadow: 0 0 8px rgba(230, 255, 255, 0.28);
}

</style>
